import type { Phase, PhaseScheduleEntry } from '@jw-av/content'

/**
 * Find the schedule entry that best matches phase + crew + team.
 * Precedence: (phase, crew, team) → (phase, crew) → (phase, team) → (phase).
 * First hit wins.
 */
export function findScheduleEntry(
  schedule: PhaseScheduleEntry[],
  phaseId: string,
  crew: string,
  team: string,
): PhaseScheduleEntry | null {
  const candidates = schedule.filter((e) => e.phase === phaseId)
  return (
    candidates.find((e) => e.crew === crew && e.team === team) ??
    candidates.find((e) => e.crew === crew && !e.team) ??
    candidates.find((e) => !e.crew && e.team === team) ??
    candidates.find((e) => !e.crew && !e.team) ??
    null
  )
}

/** Sort phases by `order`. */
export function sortPhases(phases: Phase[]): Phase[] {
  return [...phases].sort((a, b) => a.order - b.order)
}
